module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "main_layout",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "77px",
      "width": "265px",
      "margin-bottom": "50px"
    },
    attrs: {
      "src": require("../assets/chemistryAI_logo.png")
    }
  })]), _vm._v(" "), _c('md-card', {
    staticClass: "user-form-card",
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Please fill in the form:")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("All fields are required")])]), _vm._v(" "), _c('md-card-content', [_c('form', {
    staticClass: "user-form",
    on: {
      "submit": _vm.validateProfileForm
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "First Name*",
      "name": "firstname",
      "required": ""
    },
    model: {
      value: (_vm.profile.first_name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "first_name", $$v)
      },
      expression: "profile.first_name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Last Name*",
      "name": "lastname",
      "required": ""
    },
    model: {
      value: (_vm.profile.last_name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "last_name", $$v)
      },
      expression: "profile.last_name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Title*",
      "name": "title",
      "required": ""
    },
    model: {
      value: (_vm.profile.title),
      callback: function($$v) {
        _vm.$set(_vm.profile, "title", $$v)
      },
      expression: "profile.title"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Current company")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Current company*",
      "name": "affiliation",
      "required": ""
    },
    model: {
      value: (_vm.profile.affiliation),
      callback: function($$v) {
        _vm.$set(_vm.profile, "affiliation", $$v)
      },
      expression: "profile.affiliation"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("How do you classify yourself (e.g. organic chemist)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "How do you classify yourself (e.g. organic chemist)*",
      "name": "classify",
      "required": ""
    },
    model: {
      value: (_vm.profile.classify),
      callback: function($$v) {
        _vm.$set(_vm.profile, "classify", $$v)
      },
      expression: "profile.classify"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Years of experience")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number",
      "placeholder": "Years of experience*",
      "name": "experience",
      "required": ""
    },
    model: {
      value: (_vm.profile.experience),
      callback: function($$v) {
        _vm.$set(_vm.profile, "experience", $$v)
      },
      expression: "profile.experience"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Where did you do your undergraduate degree?")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Where did you do your undergraduate degree?*",
      "name": "affiliation",
      "required": ""
    },
    model: {
      value: (_vm.profile.undergraduate),
      callback: function($$v) {
        _vm.$set(_vm.profile, "undergraduate", $$v)
      },
      expression: "profile.undergraduate"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Where did you do your graduate degree?")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Where did you do your graduate degree?*",
      "name": "affiliation",
      "required": ""
    },
    model: {
      value: (_vm.profile.graduate),
      callback: function($$v) {
        _vm.$set(_vm.profile, "graduate", $$v)
      },
      expression: "profile.graduate"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Companies you worked for")]), _vm._v(" "), _c('md-textarea', {
    attrs: {
      "maxlength": "250",
      "required": ""
    },
    model: {
      value: (_vm.profile.companies),
      callback: function($$v) {
        _vm.$set(_vm.profile, "companies", $$v)
      },
      expression: "profile.companies"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Favorite target class")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Favorite target class*",
      "name": "affiliation",
      "required": ""
    },
    model: {
      value: (_vm.profile.target_class),
      callback: function($$v) {
        _vm.$set(_vm.profile, "target_class", $$v)
      },
      expression: "profile.target_class"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Email*",
      "name": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.profile.email),
      callback: function($$v) {
        _vm.$set(_vm.profile, "email", $$v)
      },
      expression: "profile.email"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Update Profile ")])], 1)])], 1), _vm._v(" "), _c('experiment-choice'), _vm._v(" "), _c('experiment-passed')], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ef44328"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 334
// module chunks = 1